// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"225":"template","272":"order-form"}[chunkId] || chunkId) + "." + {"225":"b8481e15","272":"17003560","413":"3b50bb88"}[chunkId] + ".js";
};